export enum UserServiceApiEndpoints {
    SET_PASSWORD_USING_PIN = '/v1/user/occupant/set-password',
    VALIDATE_TAX_ID = '/v1/user/validate-tax-id?taxId={taxId}',
    USER_HAS_BOOKINGS = '/v1/user/bookings',
    USER_INFO = '/v1/user/info',
    USER_META_DATA = '/v1/user/metadata',
    USER_VALIDATE_REFERRAL_CODE = '/v1/user/validate-referral-code/{referralCode}',
}
